import { LANG_EN } from "../lang/en";
import { LANG_ES } from "../lang/es";

export function textLang(lang, name) {
  return lang === 'es' ? LANG_ES[name] : LANG_EN[name]
}